import React, { useState, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from './components/LandingPage';
import PDFConverter from './components/PDFConverter';
import PDFPageRemover from './components/PDFPageRemover';
import Feedback from './components/Feedback';
import PrivacyPolicy from './components/PrivacyPolicy';
import FAQPage from './components/FAQPage';
import analytics from './services/analytics';

function App() {
  const [currentRoute, setCurrentRoute] = useState('home');

  useEffect(() => {
    // Simple hash-based routing
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Remove the #
      const route = hash || 'home';
      setCurrentRoute(route);
      
      // Track page view
      analytics.trackPageView(route);
    };

    // Set initial route
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);

    // Cleanup
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const renderCurrentPage = () => {
    switch (currentRoute) {
      case 'converter':
        return <PDFConverter />;
      case 'page-remover':
        return <PDFPageRemover />;
      case 'feedback':
        return <Feedback />;
      case 'privacy':
        return <PrivacyPolicy />;
      case 'faq':
        return <FAQPage />;
      case 'home':
      default:
        return <LandingPage />;
    }
  };

  return (
    <HelmetProvider>
      <div className="App">
        {renderCurrentPage()}
      </div>
    </HelmetProvider>
  );
}

export default App;